// extracted by mini-css-extract-plugin
module.exports = {"spinnerOverlay":"Loader__spinnerOverlay__2QQ7X","spinner":"Loader__spinner__2aRPI","text":"Loader__text__3Kxy-","showSpinner":"Loader__showSpinner__1dOdR"};